import React, { useEffect, useState } from "react";
import authQueries from '../../../queries/authQueries';
import { Link } from "react-router-dom";



const PnpList =()=>{

    const [result, setResult] = useState([])

  
    useEffect(()=>{
        mutateAsync({search: '', status: '', page:0, size:25});
    },[]);


    const { mutateAsync } = authQueries.usePnpMutationList(

        (response) => {
            setResult(response)            
        }   
    
    );



    let sl = 1
    return(
        <div>

            <Link to="/dashboard">Add Pnp</Link>

            
            {
                result?.data?.items?.map((item, index) =>(
                    <div key={index}>
                        {sl++} {item.type_of_visa}
                    </div>
                ))
            }

        <tbody>
          {(() => {
            let rows = [];
            for (let i = 0; i < result?.data?.totalPages; i++) {
              rows.push(<button onClick={()=>{mutateAsync({page:i, size:25})}}>{i+1}</button>);
            }
            return rows;
          })()}

        </tbody>

        </div>
    )
}

export default PnpList